import { useRef } from 'react';
import { ICounterOfferEntity, useDeclineCandidateMutation } from '~/domain/Jobs';
import { useToggle } from '~/hooks';

interface IUseDeclineInterview {
  professionalId: string;
}

export const useDeclineInterview = ({ professionalId }: IUseDeclineInterview) => {
  const declineCandidateMutation = useDeclineCandidateMutation();

  const selectedInterviewIdRef = useRef<string | null>(null);
  const counterOfferRef = useRef<ICounterOfferEntity | null>(null);
  const [isOpen, controls] = useToggle();

  const handleDeclineInterview = (interviewId: string, counterOffer: ICounterOfferEntity) => {
    selectedInterviewIdRef.current = interviewId;
    counterOfferRef.current = counterOffer;
    controls.setOn();
  };

  const handleConfirmDeclineInterview = () => {
    if (!selectedInterviewIdRef.current || !counterOfferRef.current) return;
    declineCandidateMutation.mutate({
      jobId: selectedInterviewIdRef.current,
      counterOfferId: counterOfferRef.current.id,
      cancellation_reason: '',
      candidateId: professionalId,
    });
  };

  const handleCloseDeclineInterview = () => {
    selectedInterviewIdRef.current = null;
    counterOfferRef.current = null;
    controls.setOff();
    declineCandidateMutation.reset();
  };

  return {
    isDeclineSuccess: declineCandidateMutation.isSuccess,
    isDeclining: declineCandidateMutation.isPending,
    isOpen,
    selectedInterviewId: selectedInterviewIdRef.current,
    handleCloseDeclineInterview,
    handleConfirmDeclineInterview,
    handleDeclineInterview,
  };
};
